<template>
  <md-switch
    class="custom-switch"
    v-model="switchValue"
    data-test-id="switch"
    @change="$emit('switchChange', switchValue)"
  >
    {{ label }}
  </md-switch>
</template>

<script>
  export default {
    name: 'switch-wrapper',
    props: {
      label: { type: String, default: '' }
    },
    emits: ['switchChange'],
    data () {
      return {
        switchValue: false
      }
    }
  }
</script>

<style scoped lang="scss">
@import '~scss/variables';

.custom-switch {
  &.md-switch {
    margin: 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/vue/common/UI/SwitchWrapper.vue